import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'src/app/Services/User/user.service';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { ToastService } from 'src/app/Services/toast/toast.service';
@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit {
  showPass1: boolean;
  showPass2: boolean;
  form_group!: FormGroup;
  submitted = false;
  match: boolean;
  faEye = faEye;
  hide = true;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private userService: UserService,
    private toast:ToastService
  ) {
    this.showPass1 = false;
    this.showPass2 = false;
    this.match = false;
  }

  ngOnInit(): void {
    this.form();
  }

  form() {
    this.form_group = this.formBuilder.group({
      password1: ['', [Validators.required, Validators.minLength(6)]],
      password2: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  get f() {
    return this.form_group.controls;
  }

  handlePass2Change(event: any) {
    const { password1, password2 } = this.form_group.value;
    this.match = password1 === password2;
  }

  onSubmit() {
    this.submitted = true;
    if (this.form_group.invalid || !this.match) {
      return;
    }

    const email = localStorage.getItem('email'); // Get the email from local storage or any other source
    const otp = localStorage.getItem('otp'); // Get the OTP from local storage or any other source
    const newPassword = this.form_group.value.password1;
    console.log(otp);
    console.log(email);

    this.userService.resetPassword(email, otp, newPassword).subscribe(
      (response) => {
        // Handle the success response
        this.toast.SuccessToast("Password succesfully reset  ! Enjoy");
        console.log('Password reset successful');
        this.router.navigate(['/home/login']); // Navigate to the login page or any other page
      },
      (error) => {
        // Handle the error response
        console.error('Failed to reset password:', error);
        this.toast.ErrorToast("Password reset failed !Try to reset again");
        // You can show an error message to the user or handle the error in any way you prefer
      }
    );
  }
}
